import { render, staticRenderFns } from "./ColorTagPicker.vue?vue&type=template&id=245591b4"
import script from "./ColorTagPicker.vue?vue&type=script&lang=js"
export * from "./ColorTagPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports